module.exports = __webpack_public_path__ + "static/media/bloodtrail_screenshot.cb60580e.webp";